/** Минимальные поля для группировки pending на странице оплаты. */
export type PendingPaymentLike = {
  id: number;
  status: string;
  payment_url?: string | null;
  created_at: string;
};

/** Ссылку на шлюз не считаем активной дольше этого срока. */
export const PAYMENT_LINK_MAX_AGE_MS = 24 * 60 * 60 * 1000;
/** Очень старые pending — в архивный блок. */
export const PENDING_ARCHIVE_MS = 72 * 60 * 60 * 1000;

export function paymentAgeMs(createdAt: string, now: number): number | null {
  const t = new Date(createdAt).getTime();
  if (!Number.isFinite(t)) return null;
  return now - t;
}

export type CheckoutBuckets<T extends PendingPaymentLike = PendingPaymentLike> = {
  withLiveLink: T[];
  pendingOther: T[];
  archived: T[];
};

export function bucketPendingCheckout<T extends PendingPaymentLike>(items: T[], now: number = Date.now()): CheckoutBuckets<T> {
  const withLiveLink: T[] = [];
  const pendingOther: T[] = [];
  const archived: T[] = [];
  for (const p of items) {
    const ageMs = paymentAgeMs(p.created_at, now);
    const age = ageMs ?? 0;
    if (p.status === 'pending' && ageMs != null && age > PENDING_ARCHIVE_MS) {
      archived.push(p);
      continue;
    }
    const url = (p.payment_url ?? '').trim();
    const linkFresh = ageMs == null || age <= PAYMENT_LINK_MAX_AGE_MS;
    if (p.status === 'pending' && url !== '' && linkFresh) {
      withLiveLink.push(p);
      continue;
    }
    pendingOther.push(p);
  }
  return { withLiveLink, pendingOther, archived };
}

export function isPaymentLinkExpired(p: PendingPaymentLike, now: number): boolean {
  if (p.status !== 'pending') return false;
  const url = (p.payment_url ?? '').trim();
  if (!url) return false;
  const ageMs = paymentAgeMs(p.created_at, now);
  if (ageMs == null) return false;
  return ageMs > PAYMENT_LINK_MAX_AGE_MS;
}
